export const SecondaryValueType = {
  CURRENCY: 'currency',
  REMOTE_ID: 'remoteId',
};
